import React from "react";
import { styled, keyframes } from "@mui/system";
import { GrAnnounce } from "react-icons/gr";

/* ---------------- Animation ---------------- */
const fadeSlide = keyframes`
  0% { opacity: 0; transform: translateY(6px); }
  100% { opacity: 1; transform: translateY(0); }
`;

/* ---------------- Styled Component ---------------- */
const Wrapper = styled("div")({
    width: "100%",
    maxWidth: "900px",
    margin: "0 auto 20px auto",
    padding: "16px 22px",
   // backgroundColor: "rgba(255,255,255,0.15)",
  //  borderRadius: "12px",
    backdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "14px",
    color: "white",
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 500,
    fontSize: "0.95rem",
   // border: "1px solid rgba(255,255,255,0.3)",
    animation: `${fadeSlide} 0.6s ease-out`,
    textAlign: "center",
    lineHeight: 1.6,
});

/* ---------------- Component ---------------- */
export default function NewsUpdate() {
    return (
        <Wrapper >
            <GrAnnounce style={{ color: "#FFD700", fontSize: "24px" }} />
            <span>
            Latest Update: Register for full‑stack mentorship and self-paced training
             </span>
        </Wrapper>
    );
}
